module.exports = __webpack_public_path__ + "img/14.28e5cfec.jpg";